/*
 *
 * PatientOverviewPage reducer
 *
 */

import { fromJS } from "immutable";
import {
  DEFAULT_ACTION,
  GET_PAGINATION_RESULTS_FAILED_ACTION,
  GET_PAGINATION_RESULTS_ACTION,
  GET_PAGINATION_RESULTS_SUCCESS_ACTION,
} from "./constants";

export const initialState = fromJS({
  paginatedResult: [],
  pageNumbers: 0,
  paginationLoading: false,
});

function calculatePageNumbers(result) {
  return Math.ceil(result.total / result.limit);
}

function patientOverviewPageReducer(state = initialState, action) {
  switch (action.type) {
    case GET_PAGINATION_RESULTS_ACTION:
      return state.set("paginationLoading", true);
    case GET_PAGINATION_RESULTS_SUCCESS_ACTION:
      return state
        .set("paginationLoading", false)
        .set("pageNumbers", calculatePageNumbers(action.result))
        .set("paginatedResult", action.result);
    case GET_PAGINATION_RESULTS_FAILED_ACTION:
      return state
        .set("paginationLoading", false)
        .set("paginatedResult", action.reason);
    case DEFAULT_ACTION:
      return state;
    default:
      return state;
  }
}

export default patientOverviewPageReducer;
